import dom from '../../utils/dom';


class ControlGroup {
  /**
   * @param {HTMLFormElement} $form 
   * @param {string} id 
   */
  constructor($form, id) {
    this.id = id;
    this.$el = dom.findFrom($form, `[data-control-group-for='${id}']`);
    this.$inputs = dom.findAllFrom(this.$el, 'input, select, textarea');
  }

  clearErrors() {
    this.$el.classList.remove('has-error');

    const $helpBlock = this.findHelpBlock();

    if ($helpBlock) {
      dom.remove($helpBlock);
    }

    this.$inputs
      .filter($el => $el.required)
      .forEach($el => $el.setAttribute('aria-invalid', 'false'));
  }

  showError(message) {
    this.$el.classList.add('has-error');

    let $helpBlock = this.findHelpBlock();
    
    if (!$helpBlock) {
      $helpBlock = createHelpBlock(this.id);

      this.$el.appendChild($helpBlock);
    }

    $helpBlock.innerHTML = message;

    this.$inputs
      .filter($el => $el.required)
      .forEach($el => {
        if ($el.type === 'checkbox' && $el.checked) {
          return;
        }

        $el.setAttribute('aria-invalid', 'true');
      });
}

  findHelpBlock() {
    return dom.findFrom(this.$el, '.help-block');
  }
}

function createHelpBlock(id) {
  return dom.makeElement('div', {id: `tn-help-block-${id}`, class: `help-block`});
}


export default ControlGroup;


// WEBPACK FOOTER //
// ./src/tnew/lib/ControlGroup.js